import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthFacade } from '../store';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanLoad {
    constructor(private router: Router, private authFacade: AuthFacade) {}

    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        const isAuthenticated = this.authFacade.isAuth;
        if (!isAuthenticated) {
            this.router.navigateByUrl('/login');
            return false;
        }
        return true;
    }
}

@Injectable({
    providedIn: 'root'
})
export class NonAuthGuard implements CanLoad {
    constructor(private router: Router, private authFacade: AuthFacade) {}

    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        const isAuthenticated = this.authFacade.isAuth;
        if (isAuthenticated) {
            this.router.navigateByUrl('/sell-now/products');
            return false;
        }
        return true;
    }
}
